import NiceModal from '@ebay/nice-modal-react'

import { ILoadedScript } from '#state'

import { CustomizeScriptFormat } from './CustomizeScriptFormat'

const CustomizeScriptFormatModal = NiceModal.create(CustomizeScriptFormat)
export const showCustomizeFormatModal = (script: ILoadedScript) => {
  NiceModal.show(CustomizeScriptFormatModal, { script })
}
